import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CompanyItemTable from './components/expirations'


const CompanyTableList = (props) => (

    <Container>
        <CompanyItemTable {...props} />
    </Container>
);

CompanyTableList.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(CompanyTableList);

